import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

//========================= publicRoutes routes start define ==============
export const publicRoutes = [
  {
    key: "index",
    path: `${AUTH_PREFIX_PATH}/`,
    component: React.lazy(() => import("pages/commonPages/index")),
  },
  {
    key: "resetpassword",
    path: `${AUTH_PREFIX_PATH}/resetpassword`,
    component: React.lazy(() => import("pages/commonPages/ResetPassword")),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() => import("pages/commonPages/ForgotPassword")),
  },
  {
    key: "registration",
    path: `${AUTH_PREFIX_PATH}/registration/:id`,
    component: React.lazy(() => import("pages/commonPages/Registration")),
  },
  {
    key: "registration1",
    path: `${AUTH_PREFIX_PATH}/registration1`,
    component: React.lazy(() => import("pages/commonPages/r1")),
  },
];
//========================= publicRoutes routes end define ==============

//========================= protectedRoutes routes start define ==============

export const protectedRoutes = {
  "Super-Admin": [
    {
      key: "dashboard",
      path: `${APP_PREFIX_PATH}/dashboard`,
      component: React.lazy(
        () => import("pages/superAdminPages/SuperAdminDashboard"),
      ),
    },
    {
      key: "profile",
      path: `${APP_PREFIX_PATH}/profile`,
      component: React.lazy(
        () => import("pages/superAdminPages/SuperAdminProfile"),
      ),
    },
    {
      key: "units",
      path: `${APP_PREFIX_PATH}/units`,
      component: React.lazy(
        () => import("pages/superAdminPages/SuperAdminListUnit"),
      ),
    },
    {
      key: "deletedUnits",
      path: `${APP_PREFIX_PATH}/deletedUnits`,
      component: React.lazy(
        () => import("pages/superAdminPages/SuperAdminDeletedUnitList"),
      ),
    },
    {
      key: "viewUnit",
      path: `${APP_PREFIX_PATH}/viewUnit/:id`,
      component: React.lazy(
        () => import("pages/superAdminPages/SuperAdminViewUnit"),
      ),
    },
    //======shift==========================
    {
      key: "shifts",
      path: `${APP_PREFIX_PATH}/shifts`,
      component: React.lazy(
        () => import("pages/superAdminPages/SuperAdminListShift"),
      ),
    },
    {
      key: "deletedShifts",
      path: `${APP_PREFIX_PATH}/deletedShifts`,
      component: React.lazy(
        () => import("pages/superAdminPages/SuperAdminDeletedShiftList"),
      ),
    },
    {
      key: "addShift",
      path: `${APP_PREFIX_PATH}/addShift`,
      component: React.lazy(
        () => import("pages/superAdminPages/SuperAdminAddShift"),
      ),
    },
    {
      key: "editShift",
      path: `${APP_PREFIX_PATH}/editShift/:id`,
      component: React.lazy(
        () => import("pages/superAdminPages/SuperAdminEditShift"),
      ),
    },
    {
      key: "viewShift",
      path: `${APP_PREFIX_PATH}/viewShift/:id`,
      component: React.lazy(
        () => import("pages/superAdminPages/SuperAdminViewShift"),
      ),
    },
    {
      key: "admin",
      path: `${APP_PREFIX_PATH}/admin`,
      component: React.lazy(
        () => import("pages/superAdminPages/SuperAdminListAdmin"),
      ),
    },
    {
      key: "addAdmin",
      path: `${APP_PREFIX_PATH}/addAdmin`,
      component: React.lazy(
        () => import("pages/superAdminPages/SuperAdminAddAdmin"),
      ),
    },
    {
      key: "editAdmin",
      path: `${APP_PREFIX_PATH}/editAdmin/:id`,
      component: React.lazy(
        () => import("pages/superAdminPages/SuperAdminEditAdmin"),
      ),
    },
    {
      key: "viewAdmin",
      path: `${APP_PREFIX_PATH}/viewAdmin/:id`,
      component: React.lazy(
        () => import("pages/superAdminPages/SuperAdminViewAdmin"),
      ),
    },
    {
      key: "createregistration",
      path: `${APP_PREFIX_PATH}/addRegistration`,
      component: React.lazy(() => import("pages/commonPages/AddRegistration")),
    },
    {
      key: "reinitregistration",
      path: `${APP_PREFIX_PATH}/addRegistration/:id`,
      component: React.lazy(() => import("pages/commonPages/AddRegistration")),
    },
    {
      key: "editregistration",
      path: `${APP_PREFIX_PATH}/editRegistration/:id`,
      component: React.lazy(() => import("pages/commonPages/EditRegistration")),
    },
    {
      key: "registration",
      path: `${APP_PREFIX_PATH}/registration`,
      component: React.lazy(() => import("pages/commonPages/ListRegistration")),
    },
    {
      key: "employees",
      path: `${APP_PREFIX_PATH}/employees`,
      component: React.lazy(
        () => import("pages/superAdminPages/SuperAdminListEmployee"),
      ),
    },
    {
      key: "addEmployee",
      path: `${APP_PREFIX_PATH}/addEmployee`,
      component: React.lazy(
        () => import("pages/superAdminPages/SuperAdminAddEmployee"),
      ),
    },
    {
      key: "editEmployee",
      path: `${APP_PREFIX_PATH}/editEmployee/:id`,
      component: React.lazy(
        () => import("pages/superAdminPages/SuperAdminEditEmployee"),
      ),
    },
    {
      key: "deletedEmployees",
      path: `${APP_PREFIX_PATH}/deletedEmployees`,
      component: React.lazy(
        () => import("pages/superAdminPages/SuperAdminDeleteEmployeeList"),
      ),
    },
    {
      key: "employee",
      path: `${APP_PREFIX_PATH}/employee/:id`,
      component: React.lazy(
        () => import("pages/superAdminPages/SuperAdminViewEmployee"),
      ),
    },
    {
      key: "departments",
      path: `${APP_PREFIX_PATH}/departments`,
      component: React.lazy(
        () => import("pages/superAdminPages/SuperAdminListDepartment"),
      ),
    },
    {
      key: "teams",
      path: `${APP_PREFIX_PATH}/teams`,
      component: React.lazy(
        () => import("pages/superAdminPages/SuperAdminListTeam"),
      ),
    },
    {
      key: "holidays",
      path: `${APP_PREFIX_PATH}/holidays`,
      component: React.lazy(() => import("pages/commonPages/ListHoliday")),
    },
    {
      key: "permissions",
      path: `${APP_PREFIX_PATH}/permissions`,
      component: React.lazy(
        () => import("pages/superAdminPages/SuperAdminListPermissions"),
      ),
    },
    {
      key: "editPermission",
      path: `${APP_PREFIX_PATH}/editPermission/:id`,
      component: React.lazy(
        () => import("pages/superAdminPages/SuperAdminEditPermissions"),
      ),
    },
    {
      key: "listattendance",
      path: `${APP_PREFIX_PATH}/attendances`,
      component: React.lazy(() => import("pages/commonPages/ListAttendance")),
    },
    {
      key: "listmyattendance",
      path: `${APP_PREFIX_PATH}/listmyattendance`,
      component: React.lazy(() => import("pages/commonPages/MyAttendance")),
    },
    {
      key: "viewattendance",
      path: `${APP_PREFIX_PATH}/viewAttendance/:id`,
      component: React.lazy(() => import("pages/commonPages/ViewAttendance")),
    },
    {
      key: "listleave",
      path: `${APP_PREFIX_PATH}/leaves`,
      component: React.lazy(() => import("pages/commonPages/ListLeaveRequest")),
    },
    {
      key: "listmyleave",
      path: `${APP_PREFIX_PATH}/myLeaves`,
      component: React.lazy(() => import("pages/commonPages/Myleave")),
    },
    {
      key: "viewleave",
      path: `${APP_PREFIX_PATH}/viewLeave/:id`,
      component: React.lazy(() => import("pages/commonPages/ViewLeave")),
    },
    {
      key: "listreg-request",
      path: `${APP_PREFIX_PATH}/regrequests`,
      component: React.lazy(
        () => import("pages/commonPages/ListRegularization"),
      ),
    },
    {
      key: "listreimbursement",
      path: `${APP_PREFIX_PATH}/reimbursements`,
      component: React.lazy(
        () => import("pages/commonPages/ListReimbursement"),
      ),
    },
    {
      key: "listcompoff",
      path: `${APP_PREFIX_PATH}/compoffs`,
      component: React.lazy(() => import("pages/commonPages/ListCompoff")),
    },
    {
      key: "listannouncement",
      path: `${APP_PREFIX_PATH}/announcement`,
      component: React.lazy(() => import("pages/commonPages/Announcement")),
    },
    {
      key: "listincentivepolicies",
      path: `${APP_PREFIX_PATH}/incentivepolicies`,
      component: React.lazy(
        () => import("pages/commonPages/ListIncentivePolicy.js"),
      ),
    },
    {
      key: "listincentive",
      path: `${APP_PREFIX_PATH}/incentives`,
      component: React.lazy(() => import("pages/commonPages/ListIncentive")),
    },
    {
      key: "listmyincentive",
      path: `${APP_PREFIX_PATH}/myincentive`,
      component: React.lazy(() => import("pages/commonPages/MyIncentive")),
    },

    {
      key: "listpayroll",
      path: `${APP_PREFIX_PATH}/payrolls`,
      component: React.lazy(
        () => import("pages/commonPages/ListMonthlyProccess"),
      ),
    },
    {
      key: "listcompensation",
      path: `${APP_PREFIX_PATH}/compensation`,
      component: React.lazy(() => import("pages/commonPages/ListProccess")),
    },
    {
      key: "listdevice",
      path: `${APP_PREFIX_PATH}/devices`,
      component: React.lazy(() => import("pages/commonPages/ListDevice")),
    },
    {
      key: "blankPage",
      path: `${APP_PREFIX_PATH}/blankPage`,
      component: React.lazy(() => import("pages/commonPages/BlankPage")),
    },
    //======Asset Handover==========================
    {
      key: "assethandoverform",
      path: `${APP_PREFIX_PATH}/asset-handover-form`,
      component: React.lazy(
        () => import("pages/commonPages/assetHandover/AssetHandoverForm"),
      ),
    },
    {
      key: "listhandover",
      path: `${APP_PREFIX_PATH}/handovers`,
      component: React.lazy(
        () => import("pages/commonPages/assetHandover/AssetHandoverList"),
      ),
    },
    {
      key: "listmyhandover",
      path: `${APP_PREFIX_PATH}/my-handovers`,
      component: React.lazy(
        () => import("pages/commonPages/assetHandover/MyAssetHandovers"),
      ),
    },
    {
      key: "listhandover",
      path: `${APP_PREFIX_PATH}/handovers/:id`,
      component: React.lazy(
        () => import("pages/commonPages/assetHandover/AssetHandoverList"),
      ),
    },
    {
      key: "listmyhandover",
      path: `${APP_PREFIX_PATH}/my-handovers/:id`,
      component: React.lazy(
        () => import("pages/commonPages/assetHandover/MyAssetHandovers"),
      ),
    },
  ],
  Admin: [
    {
      key: "dashboard",
      path: `${APP_PREFIX_PATH}/dashboard`,
      component: React.lazy(() => import("pages/adminPages/AdminDashboard")),
    },
    {
      key: "profile",
      path: `${APP_PREFIX_PATH}/profile`,
      component: React.lazy(
        () => import("pages/employeePages/EmployeeProfile"),
      ),
    },
    {
      key: "listunit",
      path: `${APP_PREFIX_PATH}/units`,
      component: React.lazy(() => import("pages/adminPages/AdminListUnit")),
    },
    {
      key: "viewunit",
      path: `${APP_PREFIX_PATH}/viewUnit/:id`,
      component: React.lazy(() => import("pages/adminPages/AdminViewUnit")),
    },
    //======shift==========================
    {
      key: "listshift",
      path: `${APP_PREFIX_PATH}/shifts`,
      component: React.lazy(() => import("pages/adminPages/AdminListShift")),
    },
    {
      key: "createshift",
      path: `${APP_PREFIX_PATH}/addShift`,
      component: React.lazy(() => import("pages/adminPages/AdminAddShift")),
    },
    {
      key: "updateshift",
      path: `${APP_PREFIX_PATH}/editShift/:id`,
      component: React.lazy(() => import("pages/adminPages/AdminEditShift")),
    },
    {
      key: "viewshift",
      path: `${APP_PREFIX_PATH}/viewShift/:id`,
      component: React.lazy(() => import("pages/adminPages/AdminViewShift")),
    },
    //======admin==========================
    {
      key: "listadmin",
      path: `${APP_PREFIX_PATH}/admin`,
      component: React.lazy(() => import("pages/adminPages/AdminListAdmin")),
    },
    {
      key: "createadmin",
      path: `${APP_PREFIX_PATH}/addAdmin`,
      component: React.lazy(() => import("pages/adminPages/AdminAddAdmin")),
    },
    {
      key: "updateadmin",
      path: `${APP_PREFIX_PATH}/editAdmin/:id`,
      component: React.lazy(() => import("pages/adminPages/AdminEditAdmin")),
    },
    {
      key: "viewadmin",
      path: `${APP_PREFIX_PATH}/viewAdmin/:id`,
      component: React.lazy(() => import("pages/adminPages/AdminViewAdmin")),
    },
    //======employees==========================
    {
      key: "createregistration",
      path: `${APP_PREFIX_PATH}/addRegistration`,
      component: React.lazy(() => import("pages/commonPages/AddRegistration")),
    },
    {
      key: "createregistration",
      path: `${APP_PREFIX_PATH}/addRegistration/:id`,
      component: React.lazy(() => import("pages/commonPages/AddRegistration")),
    },
    {
      key: "updateregistration",
      path: `${APP_PREFIX_PATH}/editRegistration/:id`,
      component: React.lazy(() => import("pages/commonPages/EditRegistration")),
    },
    {
      key: "listregistration",
      path: `${APP_PREFIX_PATH}/registration`,
      component: React.lazy(() => import("pages/commonPages/ListRegistration")),
    },

    {
      key: "listemployee",
      path: `${APP_PREFIX_PATH}/employees`,
      component: React.lazy(() => import("pages/adminPages/AdminListEmployee")),
    },

    {
      key: "createemployee",
      path: `${APP_PREFIX_PATH}/addEmployee`,
      component: React.lazy(() => import("pages/adminPages/AdminAddEmployee")),
    },
    {
      key: "updateemployee",
      path: `${APP_PREFIX_PATH}/editEmployee/:id`,
      component: React.lazy(() => import("pages/adminPages/AdminEditEmployee")),
    },
    {
      key: "viewemployee",
      path: `${APP_PREFIX_PATH}/employee/:id`,
      component: React.lazy(() => import("pages/adminPages/AdminViewEmployee")),
    },
    {
      key: "listpayroll",
      path: `${APP_PREFIX_PATH}/payrolls`,
      component: React.lazy(
        () => import("pages/commonPages/ListMonthlyProccess"),
      ),
    },
    {
      key: "listcompensation",
      path: `${APP_PREFIX_PATH}/compensation`,
      component: React.lazy(() => import("pages/commonPages/ListProccess")),
    },
    {
      key: "listdepartment",
      path: `${APP_PREFIX_PATH}/departments`,
      component: React.lazy(
        () => import("pages/adminPages/AdminListDepartment"),
      ),
    },
    {
      key: "listteam",
      path: `${APP_PREFIX_PATH}/teams`,
      component: React.lazy(() => import("pages/adminPages/AdminListTeam")),
    },
    {
      key: "listholiday",
      path: `${APP_PREFIX_PATH}/holidays`,
      component: React.lazy(() => import("pages/commonPages/ListHoliday")),
    },
    {
      key: "listmyholiday",
      path: `${APP_PREFIX_PATH}/myholidays`,
      component: React.lazy(() => import("pages/commonPages/Holiday")),
    },
    {
      key: "listpermission",
      path: `${APP_PREFIX_PATH}/permissions`,
      component: React.lazy(
        () => import("pages/adminPages/AdminListPermissions"),
      ),
    },
    {
      key: "updatePermission",
      path: `${APP_PREFIX_PATH}/editPermission/:id`,
      component: React.lazy(
        () => import("pages/adminPages/AdminEditPermissions"),
      ),
    },

    {
      key: "listattendance",
      path: `${APP_PREFIX_PATH}/attendances`,
      component: React.lazy(() => import("pages/commonPages/ListAttendance")),
    },
    {
      key: "listmyattendance",
      path: `${APP_PREFIX_PATH}/myattendance`,
      component: React.lazy(() => import("pages/commonPages/MyAttendance")),
    },
    {
      key: "viewattendance",
      path: `${APP_PREFIX_PATH}/viewAttendance/:id`,
      component: React.lazy(() => import("pages/commonPages/ViewAttendance")),
    },
    {
      key: "listleave",
      path: `${APP_PREFIX_PATH}/leaves`,
      component: React.lazy(() => import("pages/commonPages/ListLeaveRequest")),
    },
    {
      key: "listmyleave",
      path: `${APP_PREFIX_PATH}/myLeaves`,
      component: React.lazy(() => import("pages/commonPages/Myleave")),
    },
    {
      key: "viewleave",
      path: `${APP_PREFIX_PATH}/viewLeave/:id`,
      component: React.lazy(() => import("pages/commonPages/ViewLeave")),
    },
    {
      key: "listreg-request",
      path: `${APP_PREFIX_PATH}/regrequests`,
      component: React.lazy(
        () => import("pages/commonPages/ListRegularization"),
      ),
    },
    {
      key: "listmyreg-request",
      path: `${APP_PREFIX_PATH}/myregrequest`,
      component: React.lazy(() => import("pages/commonPages/MyRegularization")),
    },
    {
      key: "listreimbursement",
      path: `${APP_PREFIX_PATH}/reimbursements`,
      component: React.lazy(
        () => import("pages/commonPages/ListReimbursement"),
      ),
    },
    {
      key: "listmyreimbursement",
      path: `${APP_PREFIX_PATH}/myreimbursement`,
      component: React.lazy(() => import("pages/commonPages/MyReimbursement")),
    },
    {
      key: "listcompoff",
      path: `${APP_PREFIX_PATH}/compoffs`,
      component: React.lazy(() => import("pages/commonPages/ListCompoff")),
    },
    {
      key: "listmycompoff",
      path: `${APP_PREFIX_PATH}/mycompoff`,
      component: React.lazy(() => import("pages/commonPages/MyCompoff")),
    },
    {
      key: "listannouncement",
      path: `${APP_PREFIX_PATH}/announcement`,
      component: React.lazy(() => import("pages/commonPages/Announcement")),
    },
    {
      key: "listincentivepolicies",
      path: `${APP_PREFIX_PATH}/incentivepolicies`,
      component: React.lazy(
        () => import("pages/commonPages/ListIncentivePolicy.js"),
      ),
    },
    {
      key: "listincentive",
      path: `${APP_PREFIX_PATH}/incentives`,
      component: React.lazy(() => import("pages/commonPages/ListIncentive")),
    },
    {
      key: "listmyincentive",
      path: `${APP_PREFIX_PATH}/myincentive`,
      component: React.lazy(() => import("pages/commonPages/MyIncentive")),
    },
    {
      key: "listmysalaryslip",
      path: `${APP_PREFIX_PATH}/mysalaryslip`,
      component: React.lazy(
        () => import("pages/commonPages/MyMonthlyProccess"),
      ),
    },
    //======Asset Handover==========================
    {
      key: "listhandover",
      path: `${APP_PREFIX_PATH}/handovers`,
      component: React.lazy(
        () => import("pages/commonPages/assetHandover/AssetHandoverList"),
      ),
    },
    {
      key: "listmyhandover",
      path: `${APP_PREFIX_PATH}/my-handovers`,
      component: React.lazy(
        () => import("pages/commonPages/assetHandover/MyAssetHandovers"),
      ),
    },
    {
      key: "listhandover",
      path: `${APP_PREFIX_PATH}/handovers/:id`,
      component: React.lazy(
        () => import("pages/commonPages/assetHandover/AssetHandoverList"),
      ),
    },
    {
      key: "listmyhandover",
      path: `${APP_PREFIX_PATH}/my-handovers/:id`,
      component: React.lazy(
        () => import("pages/commonPages/assetHandover/MyAssetHandovers"),
      ),
    },
  ],
  "HR-Manager": [
    {
      key: "dashboard",
      path: `${APP_PREFIX_PATH}/dashboard`,
      component: React.lazy(
        () => import("pages/employeePages/EmployeeDashboard"),
      ),
    },
    {
      key: "profile",
      path: `${APP_PREFIX_PATH}/profile`,
      component: React.lazy(
        () => import("pages/employeePages/EmployeeProfile"),
      ),
    },
    //======employees==========================
    {
      key: "createregistration",
      path: `${APP_PREFIX_PATH}/addRegistration`,
      component: React.lazy(() => import("pages/commonPages/AddRegistration")),
    },
    {
      key: "reinitregistration",
      path: `${APP_PREFIX_PATH}/addRegistration/:id`,
      component: React.lazy(() => import("pages/commonPages/AddRegistration")),
    },
    {
      key: "updateregistration",
      path: `${APP_PREFIX_PATH}/editRegistration/:id`,
      component: React.lazy(() => import("pages/commonPages/EditRegistration")),
    },
    {
      key: "listregistration",
      path: `${APP_PREFIX_PATH}/registration`,
      component: React.lazy(() => import("pages/commonPages/ListRegistration")),
    },
    {
      key: "listemployee",
      path: `${APP_PREFIX_PATH}/employees`,
      component: React.lazy(() => import("pages/adminPages/AdminListEmployee")),
    },
    {
      key: "createemployee",
      path: `${APP_PREFIX_PATH}/addEmployee`,
      component: React.lazy(() => import("pages/adminPages/AdminAddEmployee")),
    },
    {
      key: "updateemployee",
      path: `${APP_PREFIX_PATH}/editEmployee/:id`,
      component: React.lazy(() => import("pages/adminPages/AdminEditEmployee")),
    },
    {
      key: "viewemployee",
      path: `${APP_PREFIX_PATH}/employee/:id`,
      component: React.lazy(() => import("pages/adminPages/AdminViewEmployee")),
    },

    {
      key: "listholiday",
      path: `${APP_PREFIX_PATH}/holidays`,
      component: React.lazy(() => import("pages/commonPages/ListHoliday")),
    },
    {
      key: "listmyholiday",
      path: `${APP_PREFIX_PATH}/myholidays`,
      component: React.lazy(() => import("pages/commonPages/Holiday")),
    },
    {
      key: "listattendance",
      path: `${APP_PREFIX_PATH}/attendances`,
      component: React.lazy(() => import("pages/commonPages/ListAttendance")),
    },
    {
      key: "listmyattendance",
      path: `${APP_PREFIX_PATH}/myattendance`,
      component: React.lazy(() => import("pages/commonPages/MyAttendance")),
    },
    {
      key: "viewattendance",
      path: `${APP_PREFIX_PATH}/viewAttendance/:id`,
      component: React.lazy(() => import("pages/commonPages/ViewAttendance")),
    },
    {
      key: "listleave",
      path: `${APP_PREFIX_PATH}/leaves`,
      component: React.lazy(() => import("pages/commonPages/ListLeaveRequest")),
    },
    {
      key: "listmyleave",
      path: `${APP_PREFIX_PATH}/myLeaves`,
      component: React.lazy(() => import("pages/commonPages/Myleave")),
    },
    {
      key: "viewleave",
      path: `${APP_PREFIX_PATH}/viewLeave/:id`,
      component: React.lazy(() => import("pages/commonPages/ViewLeave")),
    },
    {
      key: "listreg-request",
      path: `${APP_PREFIX_PATH}/regrequests`,
      component: React.lazy(
        () => import("pages/commonPages/ListRegularization"),
      ),
    },
    {
      key: "listmyreg-request",
      path: `${APP_PREFIX_PATH}/myregrequest`,
      component: React.lazy(() => import("pages/commonPages/MyRegularization")),
    },
    {
      key: "listreimbursement",
      path: `${APP_PREFIX_PATH}/reimbursements`,
      component: React.lazy(
        () => import("pages/commonPages/ListReimbursement"),
      ),
    },
    {
      key: "listmyreimbursement",
      path: `${APP_PREFIX_PATH}/myreimbursement`,
      component: React.lazy(() => import("pages/commonPages/MyReimbursement")),
    },
    {
      key: "listcompoff",
      path: `${APP_PREFIX_PATH}/compoffs`,
      component: React.lazy(() => import("pages/commonPages/ListCompoff")),
    },
    {
      key: "listmycompoff",
      path: `${APP_PREFIX_PATH}/mycompoff`,
      component: React.lazy(() => import("pages/commonPages/MyCompoff")),
    },
    {
      key: "listannouncement",
      path: `${APP_PREFIX_PATH}/announcement`,
      component: React.lazy(() => import("pages/commonPages/Announcement")),
    },
    {
      key: "listincentivepolicies",
      path: `${APP_PREFIX_PATH}/incentivepolicies`,
      component: React.lazy(
        () => import("pages/commonPages/ListIncentivePolicy.js"),
      ),
    },
    {
      key: "listincentive",
      path: `${APP_PREFIX_PATH}/incentives`,
      component: React.lazy(() => import("pages/commonPages/ListIncentive")),
    },
    {
      key: "listmyincentive",
      path: `${APP_PREFIX_PATH}/myincentive`,
      component: React.lazy(() => import("pages/commonPages/MyIncentive")),
    },
    {
      key: "listmysalaryslip",
      path: `${APP_PREFIX_PATH}/mysalaryslip`,
      component: React.lazy(
        () => import("pages/commonPages/MyMonthlyProccess"),
      ),
    },
    {
      key: "listhandover",
      path: `${APP_PREFIX_PATH}/handovers`,
      component: React.lazy(
        () => import("pages/commonPages/assetHandover/AssetHandoverList"),
      ),
    },
    {
      key: "listmyhandover",
      path: `${APP_PREFIX_PATH}/my-handovers`,
      component: React.lazy(
        () => import("pages/commonPages/assetHandover/MyAssetHandovers"),
      ),
    },
    {
      key: "listhandover",
      path: `${APP_PREFIX_PATH}/handovers/:id`,
      component: React.lazy(
        () => import("pages/commonPages/assetHandover/AssetHandoverList"),
      ),
    },
    {
      key: "listmyhandover",
      path: `${APP_PREFIX_PATH}/my-handovers/:id`,
      component: React.lazy(
        () => import("pages/commonPages/assetHandover/MyAssetHandovers"),
      ),
    },
  ],
  Manager: [
    {
      key: "dashboard",
      path: `${APP_PREFIX_PATH}/dashboard`,
      component: React.lazy(
        () => import("pages/employeePages/EmployeeDashboard"),
      ),
    },
    {
      key: "profile",
      path: `${APP_PREFIX_PATH}/profile`,
      component: React.lazy(
        () => import("pages/employeePages/EmployeeProfile"),
      ),
    },
    {
      key: "listholiday",
      path: `${APP_PREFIX_PATH}/holidays`,
      component: React.lazy(() => import("pages/commonPages/ListHoliday")),
    },
    {
      key: "listmyholiday",
      path: `${APP_PREFIX_PATH}/myholidays`,
      component: React.lazy(() => import("pages/commonPages/Holiday")),
    },
    {
      key: "listattendance",
      path: `${APP_PREFIX_PATH}/attendances`,
      component: React.lazy(() => import("pages/commonPages/ListAttendance")),
    },
    {
      key: "listmyattendance",
      path: `${APP_PREFIX_PATH}/myattendance`,
      component: React.lazy(() => import("pages/commonPages/MyAttendance")),
    },
    {
      key: "viewattendance",
      path: `${APP_PREFIX_PATH}/viewAttendance/:id`,
      component: React.lazy(() => import("pages/commonPages/ViewAttendance")),
    },
    {
      key: "listleave",
      path: `${APP_PREFIX_PATH}/leaves`,
      component: React.lazy(() => import("pages/commonPages/ListLeaveRequest")),
    },
    {
      key: "listmyleave",
      path: `${APP_PREFIX_PATH}/myLeaves`,
      component: React.lazy(() => import("pages/commonPages/Myleave")),
    },
    {
      key: "viewleave",
      path: `${APP_PREFIX_PATH}/viewLeave/:id`,
      component: React.lazy(() => import("pages/commonPages/ViewLeave")),
    },
    {
      key: "listreg-request",
      path: `${APP_PREFIX_PATH}/regrequests`,
      component: React.lazy(
        () => import("pages/commonPages/ListRegularization"),
      ),
    },
    {
      key: "listmyreg-request",
      path: `${APP_PREFIX_PATH}/myregrequest`,
      component: React.lazy(() => import("pages/commonPages/MyRegularization")),
    },
    {
      key: "listreimbursement",
      path: `${APP_PREFIX_PATH}/reimbursements`,
      component: React.lazy(
        () => import("pages/commonPages/ListReimbursement"),
      ),
    },
    {
      key: "listmyreimbursement",
      path: `${APP_PREFIX_PATH}/myreimbursement`,
      component: React.lazy(() => import("pages/commonPages/MyReimbursement")),
    },
    {
      key: "listcompoff",
      path: `${APP_PREFIX_PATH}/compoffs`,
      component: React.lazy(() => import("pages/commonPages/ListCompoff")),
    },
    {
      key: "listmycompoff",
      path: `${APP_PREFIX_PATH}/mycompoff`,
      component: React.lazy(() => import("pages/commonPages/MyCompoff")),
    },
    {
      key: "listannouncement",
      path: `${APP_PREFIX_PATH}/announcement`,
      component: React.lazy(() => import("pages/commonPages/Announcement")),
    },
    {
      key: "listincentivepolicies",
      path: `${APP_PREFIX_PATH}/incentivepolicies`,
      component: React.lazy(
        () => import("pages/commonPages/ListIncentivePolicy.js"),
      ),
    },
    {
      key: "listincentive",
      path: `${APP_PREFIX_PATH}/incentives`,
      component: React.lazy(() => import("pages/commonPages/ListIncentive")),
    },
    {
      key: "listmyincentive",
      path: `${APP_PREFIX_PATH}/myincentive`,
      component: React.lazy(() => import("pages/commonPages/MyIncentive")),
    },
    {
      key: "listmysalaryslip",
      path: `${APP_PREFIX_PATH}/mysalaryslip`,
      component: React.lazy(
        () => import("pages/commonPages/MyMonthlyProccess"),
      ),
    },
    //======Asset Handover==========================

    {
      key: "listhandover",
      path: `${APP_PREFIX_PATH}/handovers`,
      component: React.lazy(
        () => import("pages/commonPages/assetHandover/AssetHandoverList"),
      ),
    },

    {
      key: "listmyhandover",
      path: `${APP_PREFIX_PATH}/my-handovers`,
      component: React.lazy(
        () => import("pages/commonPages/assetHandover/MyAssetHandovers"),
      ),
    },
    {
      key: "listhandover",
      path: `${APP_PREFIX_PATH}/handovers/:id`,
      component: React.lazy(
        () => import("pages/commonPages/assetHandover/AssetHandoverList"),
      ),
    },
    {
      key: "listmyhandover",
      path: `${APP_PREFIX_PATH}/my-handovers/:id`,
      component: React.lazy(
        () => import("pages/commonPages/assetHandover/MyAssetHandovers"),
      ),
    },
  ],
  Employee: [
    {
      key: "dashboard",
      path: `${APP_PREFIX_PATH}/dashboard`,
      component: React.lazy(
        () => import("pages/employeePages/EmployeeDashboard"),
      ),
    },
    {
      key: "profile",
      path: `${APP_PREFIX_PATH}/profile`,
      component: React.lazy(
        () => import("pages/employeePages/EmployeeProfile"),
      ),
    },
    {
      key: "listholiday",
      path: `${APP_PREFIX_PATH}/myholidays`,
      component: React.lazy(() => import("pages/commonPages/ListHoliday")),
    },
    {
      key: "listmyholiday",
      path: `${APP_PREFIX_PATH}/myholidays`,
      component: React.lazy(() => import("pages/commonPages/Holiday")),
    },
    {
      key: "listattendance",
      path: `${APP_PREFIX_PATH}/attendances`,
      component: React.lazy(() => import("pages/commonPages/ListAttendance")),
    },
    {
      key: "listmyattendance",
      path: `${APP_PREFIX_PATH}/myattendance`,
      component: React.lazy(() => import("pages/commonPages/MyAttendance")),
    },
    {
      key: "listreg-request",
      path: `${APP_PREFIX_PATH}/regrequests`,
      component: React.lazy(
        () => import("pages/commonPages/ListRegularization"),
      ),
    },
    {
      key: "listmyreg-request",
      path: `${APP_PREFIX_PATH}/myregrequest`,
      component: React.lazy(() => import("pages/commonPages/MyRegularization")),
    },
    {
      key: "listleave",
      path: `${APP_PREFIX_PATH}/leaves`,
      component: React.lazy(() => import("pages/commonPages/ListLeaveRequest")),
    },
    {
      key: "listmyleave",
      path: `${APP_PREFIX_PATH}/myleaves`,
      component: React.lazy(() => import("pages/commonPages/Myleave")),
    },
    {
      key: "listcompoff",
      path: `${APP_PREFIX_PATH}/compoffs`,
      component: React.lazy(() => import("pages/commonPages/ListCompoff")),
    },
    {
      key: "listmycompoff",
      path: `${APP_PREFIX_PATH}/mycompoff`,
      component: React.lazy(() => import("pages/commonPages/MyCompoff")),
    },
    {
      key: "listreimbursement",
      path: `${APP_PREFIX_PATH}/reimbursements`,
      component: React.lazy(
        () => import("pages/commonPages/ListReimbursement"),
      ),
    },
    {
      key: "listmyreimbursement",
      path: `${APP_PREFIX_PATH}/myreimbursement`,
      component: React.lazy(() => import("pages/commonPages/MyReimbursement")),
    },
    {
      key: "listannouncement",
      path: `${APP_PREFIX_PATH}/announcement`,
      component: React.lazy(() => import("pages/commonPages/Announcement")),
    },
    {
      key: "listincentivepolicies",
      path: `${APP_PREFIX_PATH}/incentivepolicies`,
      component: React.lazy(
        () => import("pages/commonPages/ListIncentivePolicy.js"),
      ),
    },
    {
      key: "listincentive",
      path: `${APP_PREFIX_PATH}/incentives`,
      component: React.lazy(() => import("pages/commonPages/ListIncentive")),
    },
    {
      key: "listmyincentive",
      path: `${APP_PREFIX_PATH}/myincentive`,
      component: React.lazy(() => import("pages/commonPages/MyIncentive")),
    },
    {
      key: "listmysalaryslip",
      path: `${APP_PREFIX_PATH}/mysalaryslip`,
      component: React.lazy(
        () => import("pages/commonPages/MyMonthlyProccess"),
      ),
    },
    {
      key: "blankPage",
      path: `${APP_PREFIX_PATH}/blankPage`,
      component: React.lazy(() => import("pages/commonPages/BlankPage")),
    },
    //======Asset Handover==========================
    {
      key: "listhandover",
      path: `${APP_PREFIX_PATH}/handovers`,
      component: React.lazy(
        () => import("pages/commonPages/assetHandover/AssetHandoverList"),
      ),
    },
    {
      key: "listmyhandover",
      path: `${APP_PREFIX_PATH}/my-handovers`,
      component: React.lazy(
        () => import("pages/commonPages/assetHandover/MyAssetHandovers"),
      ),
    },
    {
      key: "listhandover",
      path: `${APP_PREFIX_PATH}/handovers/:id`,
      component: React.lazy(
        () => import("pages/commonPages/assetHandover/AssetHandoverList"),
      ),
    },
    {
      key: "listmyhandover",
      path: `${APP_PREFIX_PATH}/my-handovers/:id`,
      component: React.lazy(
        () => import("pages/commonPages/assetHandover/MyAssetHandovers"),
      ),
    },
  ],
};
